import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(dvr => ({
        value: dvr.id,
        label: dvr.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/services/pacom/master-accounts', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/services/pacom/master-accounts', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/services/pacom/master-accounts/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/services/pacom/master-accounts/${id}`)

      return data
    },
    async getResources(_, params) {
      const {
        id_pacom_master_account,
        resource,
        param = null
      } = params;
      const { data } = await axios.get(`v1/services/pacom/master-accounts/${id_pacom_master_account}/${resource}/${param}`);

      return data;
    },

    async syncTypes(_, params) {
      const { id_pacom_master_account,type } = params;
      const { data } = await axios.get(`v1/services/pacom/master-accounts/${id_pacom_master_account}/sync/${type}`);

      return data;
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
